import { createContext, useContext } from "react";

const DiscoveryPropoundingQuestionsContext = createContext(null);

export const DiscoveryPropoundingQuestionsProvider = ({ value, children }) => (
    <DiscoveryPropoundingQuestionsContext.Provider value={value}>
        {children}
    </DiscoveryPropoundingQuestionsContext.Provider>
);

export const useDiscoveryPropoundingQuestionsContext = () => {
    const context = useContext(DiscoveryPropoundingQuestionsContext);
    if (!context) {
        throw new Error("useDiscoveryPropoundingQuestionsContext must be used within DiscoveryPropoundingQuestionsProvider");
    }
    return context;
};
